/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React from 'react'
import classNames from 'classnames'
import styles from '../style/index.css'

export function getSimpleHeader(title: string) {
  return () => (
    <div className={styles['log__header']}>
      <div
        className={classNames(styles['log__header__name'], styles['log__header__name--disabled'])}
      >
        <span>{title}</span>
      </div>
    </div>
  )
}
